module.exports = __webpack_public_path__ + "fonts/OpenSans-MediumItalic.2feb8771.ttf";